module.exports = __webpack_public_path__ + "2f8ca00a85830ef21cec59dea0d7ab92.png";